var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.003,
    height: 12,
    viewBox: "0 0 12.003 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "remove",
    d: "M18.709,17.289,23,13a1,1,0,1,0-1.421-1.421l-4.287,4.287L13,11.581A1,1,0,1,0,11.581,13l4.287,4.287-4.287,4.287A1,1,0,0,0,13,23l4.287-4.287L21.575,23A1,1,0,0,0,23,21.576Z",
    transform: "translate(-11.285 -11.289)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosered);
export default __webpack_public_path__ + "static/media/closered.305c29dfd9ff9a1cd0c1a607f1027adc.svg";
export { ForwardRef as ReactComponent };